import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./scss/seller-order-details.scss";
import Icon from "../lib/icon";
import ApiImage from "../components/ApiImage";
import Button from "../components/Button";
import api from "../api";
import BadgeStatus from "../components/BadgeStatus";

export default function SellerOrderDetailsPage() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  async function load() {
    try {
      const { data } = await api.get(`/api/seller/orders/${id}`);
      setOrder(data);
    } catch {
      navigate("/seller");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, [id]);

  const [actionLoading, setActionLoading] = useState(false);

  async function handleAccept() {
    try {
      setActionLoading(true);
      await api.post(`/api/seller/orders/${id}/accept`);
      await load();
    } finally {
      setActionLoading(false);
    }
  }

  async function handleReject() {
    try {
      setActionLoading(true);
      await api.post(`/api/seller/orders/${id}/reject`);
      await load();
    } finally {
      setActionLoading(false);
    }
  }

  if (loading) return null;
  if (!order) return null;

  const statusLabel = {
    created: "Создан",
    processing: "В обработке",
    accepted: "Принят",
    delivered: "Доставлен",
    cancelled: "Отменён"
  }[order.status] || order.status;

  return (
    <div className="seller-order-details">

      {/* HEADER */}
      <div className="seller-order-details__header">
        <button
          className="seller-order-details__back"
          onClick={() => navigate(-1)}
        >
          <Icon name="arrow-left" />
          Назад
        </button>
      </div>

      {/* STATUS */}
      <div className="seller-order-details__status">
        <BadgeStatus status={statusLabel}></BadgeStatus>
      </div>

      {/* TITLE */}
      <h1 className="seller-order-details__title">
        Заказ от{" "}
        {new Date(order.dateCreate).toLocaleString("ru-RU", {
          day: "numeric",
          month: "long",
          hour: "2-digit",
          minute: "2-digit"
        })}
      </h1>

      <div className="seller-order-details__number">
        {order.orderNumber}
      </div>

      {/* ACTIONS */}
      {order.status === "new_order" && (
        <div className="seller-order-details__actions">
          <Button
            className="btn-primary large"
            onClick={handleAccept}
            load={actionLoading}
          >
            Принять заказ
          </Button>

          <button
            className="seller-order-details__reject"
            onClick={handleReject}
            disabled={actionLoading}
          >
            Отказаться от заказа
          </button>
        </div>
      )}

      {/* ITEMS */}
      <div className="seller-order-details__section">
        <div className="seller-order-details__section-title">
          Состав заказа
        </div>

        {order.items.map(item => (
          <div
            key={item.productId}
            className="seller-order-details__item"
          >
            <div className="seller-order-details__item-image">
              <ApiImage src={item.image} />
            </div>

            <div className="seller-order-details__item-info">
              <div className="seller-order-details__item-price">
                {item.price.toLocaleString("ru-RU")} ₽
                {item.oldPrice && (
                  <span>
                    {item.oldPrice.toLocaleString("ru-RU")} ₽
                  </span>
                )}
              </div>

              <div className="seller-order-details__item-name">
                {item.name}
              </div>

              <div className="seller-order-details__item-qty">
                {item.quantity} шт
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* DELIVERY */}
      <div className="seller-order-details__section">
        <div className="seller-order-details__section-title">
          Детали доставки
        </div>

        {order.address && (
          <div className="seller-order-details__block">
            <div className="seller-order-details__label">
              Адрес
            </div>

            <div className="seller-order-details__value">
              {order.address.city}, {order.address.street}
            </div>

            <div className="seller-order-details__sub">
              {order.address.entrance &&
                `${order.address.entrance} подъезд, `}
              {order.address.floor &&
                `${order.address.floor} этаж, `}
              {order.address.apartment &&
                `${order.address.apartment} квартира`}
            </div>
          </div>
        )}

        <div className="seller-order-details__block">
          <div className="seller-order-details__label">
            Дата заказа
          </div>

          <div className="seller-order-details__value">
            {new Date(order.dateCreate).toLocaleString(
              "ru-RU"
            )}
          </div>
        </div>
      </div>

      {/* CUSTOMER */}
      <div className="seller-order-details__section">
        <div className="seller-order-details__section-title">
          Данные заказчика
        </div>

        <div className="seller-order-details__hint">
          Вы можете связаться для уточнения деталей
        </div>

        <div className="seller-order-details__block">
          <div className="seller-order-details__label">
            Имя
          </div>
          <div className="seller-order-details__value">
            {order.fio}
          </div>
        </div>

        <div className="seller-order-details__block">
          <div className="seller-order-details__label">
            Телефон
          </div>
          <div className="seller-order-details__value">
            {order.phone}
          </div>
        </div>
      </div>

    </div>
  );
}
